<template>
    <svg-vue :icon="icon" alt="" v-bind="$attrs" />
</template>

<script>

import SvgVue from "./SvgVue.vue";

export default {
    name: 'VIcon',
    components: {
        SvgVue,
    },

    props: {
        icon: String
    },

    mounted() {
        if (this.$el?.viewBox) {
            let viewBox = this.$el?.viewBox?.baseVal

            this.$el.setAttribute("width", viewBox?.width + "px");
            this.$el.setAttribute("height", viewBox?.height + "px");
        }
    },
}
</script>
